import { render, staticRenderFns } from "./RecurEventMenu.vue?vue&type=template&id=09d870b1"
import script from "./RecurEventMenu.vue?vue&type=script&lang=js"
export * from "./RecurEventMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports